var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaziente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2505_42748)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188.769,
    height: 188.769,
    rx: 94.3847,
    fill: "#8DBEE9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.002 107.596V190H106.407L61.2762 144.869L90.4338 115.713L69.2899 94.5692L123.157 40.7523L190.002 107.596Z",
    fill: "#024E88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2762 144.869C61.2762 137.011 61.2762 124.913 61.2762 117.057C54.9694 102.583 46.7503 89.2953 47.4741 73.4772C48.9735 38.4274 83.3513 16.7651 114.266 33.9809C128.638 41.9946 137.218 58.6402 134.273 78.4401C136.133 83.9714 144.456 100.256 138.512 100.256C136.652 100.256 134.841 100.256 132.981 100.256C134.893 103.46 135.876 105.58 132.153 108.322C135.152 111.424 134.841 113.697 131.585 116.076C133.497 119.591 134.221 131.326 125.071 131.274C99.5841 130.965 106.046 135.513 106.046 162.705C88.0032 154.278 79.3713 153.295 61.2762 144.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8845 50.6265C62.0019 36.3578 76.837 27.5185 93.018 27.9832C98.1883 32.3778 101.444 38.8921 101.444 46.18C101.444 59.4139 90.691 70.1673 77.4571 70.1673C65.7227 70.1692 56.0041 61.7408 53.8845 50.6265Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.791 130.446C127.809 130.963 126.568 131.274 125.069 131.274C99.5821 130.965 106.044 135.513 106.044 162.705C99.8413 159.809 94.7228 157.793 89.9672 156.035C89.8117 140.113 90.3301 121.192 95.7576 122.484C105.839 128.068 117.005 130.239 128.791 130.446Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9682 64.8952C59.5713 60.6561 61.5354 56.728 63.966 53.1089C74.4602 37.3926 92.2443 33.2571 105.686 37.239C116.955 40.547 129.26 57.039 112.096 60.4507C99.1194 63.0867 86.9722 69.9619 75.3395 81.0263C64.8434 91.1058 52.7979 78.9566 57.9682 64.8952Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2602 61.7409C60.5523 58.6902 62.1554 55.795 63.9639 53.1071C72.855 39.8214 86.9164 34.8066 99.1692 35.995C100.617 39.0976 101.444 42.5611 101.444 46.1801C101.444 59.414 90.6909 70.1674 77.457 70.1674C70.1691 70.1693 63.6549 66.9112 59.2602 61.7409Z",
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2505_42748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188.769,
    height: 188.769,
    rx: 94.3847,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaziente);
export default __webpack_public_path__ + "static/media/Paziente.db0b1d758dc57226e5c37c91073f0f9f.svg";
export { ForwardRef as ReactComponent };